import Gallery from '@features/gallery/ui'
import styles from '@features/gallery/ui/styles.module.scss'
import { useModalStore } from '@features/modal'




export default function useGalleryModal () {
  const { openModal, closeModal } = useModalStore()

  const openGalleryModal = () => {
    openModal('gallery', <Gallery />, {
      classes: {
        content: styles['modal-content'],
      },
      hideIconClose: true,
    })
  }

  const closeGalleryModal = () => {
    closeModal('gallery')
  }

  return {
    openGalleryModal,
    closeGalleryModal,
  }
}
